export default __webpack_public_path__ + "static/media/LimitExhausted.9b706e32.svg";